<div
  class="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center tw-bg-black/70"
>
  <div
    appModalOverlay
    appModalOverlayLabel="Watch ad to earn credits"
    (modalOverlayDismiss)="close()"
    class="tw-bg-color-surface-card tw-rounded-2xl tw-overflow-hidden tw-w-[90%] tw-max-w-lg tw-shadow-2xl tw-flex tw-flex-col"
  >
    <!-- Header -->
    <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 border-bottom-gray">
      <span class="tw-font-Montserrat tw-text-sm tw-font-semibold tw-text-color-text-action">
        Watch to earn <span class="tw-font-bold">+{{ rewardAmount }}cr</span>
      </span>
      <button
        type="button"
        aria-label="Close"
        (click)="close()"
        class="tw-text-color-text-disabled hover:tw-text-color-text-secondary tw-leading-none tw-text-xl tw-font-light"
      >
        &#x2715;
      </button>
    </div>

    <!-- Ad Slot -->
    <div
      class="tw-w-full tw-min-h-[250px] tw-bg-color-surface-elevated tw-flex tw-items-center tw-justify-center"
    >
      <ins
        #adSlotEl
        class="adsbygoogle"
        style="display: block; min-height: 250px; width: 100%"
        [attr.data-ad-client]="publisherId"
        [attr.data-ad-slot]="adSlot"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>

    <!-- Footer -->
    <div
      class="tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between tw-bg-color-surface-elevated tw-border-0 tw-border-t tw-border-color-border-subtle"
    >
      @if (rewardGranted()) {
        <span class="tw-text-sm tw-text-color-text-tertiary">Credits ready to collect</span>
        <button
          type="button"
          (click)="close()"
          class="tw-bg-color-action-primary hover:tw-bg-color-action-primary-hover tw-text-color-text-on-action tw-rounded-xl tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-transition-colors"
        >
          Collect +{{ rewardAmount }}cr
        </button>
      } @else {
        <span class="tw-text-sm tw-text-color-text-tertiary">Reward unlocks in</span>
        <span
          class="tw-font-Montserrat tw-text-xl tw-font-bold tw-text-color-text-action tw-tabular-nums tw-min-w-[2.5rem] tw-text-right"
          >{{ countdown() }}s</span
        >
      }
    </div>
  </div>
</div>
